import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { apiKeyHeader } from "../../../../configs/ApiKeys";
import { lessonPlanner } from "../../../../configs/WebService";

export const postTopic = createAsyncThunk(
  "topic/postTopic",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${lessonPlanner}/create-topic`,
        payload,
        {
          headers: apiKeyHeader(),
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Error posting topic");
    }
  }
);

export const getTopicByIdentifiers = createAsyncThunk(
  "topic/getTopicByIdentifiers",
  async ({
    chapter,
    period_number,
    subject_id,
    class_id,
    teacher_id,
    section_id,
  }) => {
    const response = await axios.post(
      `${lessonPlanner}/get-topic`,
      {
        chapter,
        period_number,
        subject_id,
        class_id,
        teacher_id,
        section_id,
      },
      { headers: apiKeyHeader() }
    );
    return response.data.data;
  }
);
export const updateTopicThunk = createAsyncThunk(
  "lessonTopics/updateTopic",
  async ({ id, topic }, { rejectWithValue }) => {
    console.log("THUNK INPUT:", { id, topic });
    try {
      const response = await axios.put(
        `${lessonPlanner}/lesson-topics`,
        {
          id,
          topic,
        },
        { headers: apiKeyHeader() }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const createRemarksThunk = createAsyncThunk(
  "remarks/createRemarks",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${lessonPlanner}/lesson_remarks`,
        payload,
        { headers: apiKeyHeader() }
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);
export const getRemarksByIdentifiers = createAsyncThunk(
  "remarks/getRemarksByIdentifiers",
  async (filters, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${lessonPlanner}/getRemarks`,
        filters,
        { headers: apiKeyHeader() }
      );
      return response.data.data || [];
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch remarks"
      );
    }
  }
);
export const updateRemarksThunk = createAsyncThunk(
  "remarks/updateRemarks",
  async ({ id, remarks }, { rejectWithValue }) => {
    try {
      const response = await axios.put(
        `${lessonPlanner}/lesson_remarks/${id}`,
        { remarks },
        { headers: apiKeyHeader() }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to update remarks"
      );
    }
  }
);

export const createProjectThunk = createAsyncThunk(
  "topic/createProject",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${lessonPlanner}/lesson_projects`,
        payload,
        { headers: apiKeyHeader() }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const getProjectByIdentifiersThunk = createAsyncThunk(
  "topic/getProjectByIdentifiers",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${lessonPlanner}/lesson_projects/filter`,
        payload,
        { headers: apiKeyHeader() }
      );
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
export const updateProjectThunk = createAsyncThunk(
  "topic/updateProject",
  async ({ id, details }, { rejectWithValue }) => {
    try {
      const response = await axios.put(
        `${lessonPlanner}/updateProject`,
        {
          id,
          details,
        },
        { headers: apiKeyHeader() }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || { error: "Something went wrong" }
      );
    }
  }
);

export const getHomeWorkByFiltersThunk = createAsyncThunk(
  "homework/getByFilters",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${lessonPlanner}/home_work/filter`,
        payload,
        { headers: apiKeyHeader() }
      );
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const createHomeWorkThunk = createAsyncThunk(
  "homework/create",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${lessonPlanner}/home_work`, payload, {
        headers: apiKeyHeader(),
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const updateHomeWorkThunk = createAsyncThunk(
  "homework/update",
  async ({ id, details }, { rejectWithValue }) => {
    try {
      const response = await axios.put(
        `${lessonPlanner}/updateHomeWork`,
        { id, details },
        { headers: apiKeyHeader() }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
export const getAllTopicsThunk = createAsyncThunk(
  "topic/getAllTopics",
  async ({ teacher_id, school_id }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${lessonPlanner}/getTopicByTeachers`,
        {
          teacher_id,
          school_id,
        },
        { headers: apiKeyHeader() }
      );
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);
export const fetchTeacherHomework = createAsyncThunk(
  "homework/fetchTeacherHomework",
  async ({ teacher_id, school_id }, { rejectWithValue }) => {
    try {
      const res = await axios.post(
        `${lessonPlanner}/teacherHw`,
        { teacher_id, school_id },
        { headers: apiKeyHeader() }
      );
      return res.data.data;
    } catch (err) {
      return rejectWithValue(err.response.data.message);
    }
  }
);



export const updateTopicStatusThunk = createAsyncThunk(
  "topic/updateTopicStatus",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${lessonPlanner}/update-topic-status`,
        payload,
        { headers: apiKeyHeader() }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to update topic status"
      );
    }
  }
);

